import { render } from "./section-aboutus.vue?vue&type=template&id=2265695c&scoped=true"
import script from "./section-aboutus.vue?vue&type=script&lang=js"
export * from "./section-aboutus.vue?vue&type=script&lang=js"

import "./section-aboutus.vue?vue&type=style&index=0&id=2265695c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2265695c"]])

export default __exports__